/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    DatabaseBannerHeaderBlock,
    instanceOfDatabaseBannerHeaderBlock,
    DatabaseBannerHeaderBlockFromJSON,
    DatabaseBannerHeaderBlockFromJSONTyped,
    DatabaseBannerHeaderBlockToJSON,
} from './DatabaseBannerHeaderBlock';
import {
    DatabaseCustomerLogoHeaderBlock,
    instanceOfDatabaseCustomerLogoHeaderBlock,
    DatabaseCustomerLogoHeaderBlockFromJSON,
    DatabaseCustomerLogoHeaderBlockFromJSONTyped,
    DatabaseCustomerLogoHeaderBlockToJSON,
} from './DatabaseCustomerLogoHeaderBlock';
import {
    DatabaseDbMenuHeaderBlock,
    instanceOfDatabaseDbMenuHeaderBlock,
    DatabaseDbMenuHeaderBlockFromJSON,
    DatabaseDbMenuHeaderBlockFromJSONTyped,
    DatabaseDbMenuHeaderBlockToJSON,
} from './DatabaseDbMenuHeaderBlock';
import {
    DatabaseDescriptionHeaderBlock,
    instanceOfDatabaseDescriptionHeaderBlock,
    DatabaseDescriptionHeaderBlockFromJSON,
    DatabaseDescriptionHeaderBlockFromJSONTyped,
    DatabaseDescriptionHeaderBlockToJSON,
} from './DatabaseDescriptionHeaderBlock';
import {
    DatabaseEingabelisteHeaderBlock,
    instanceOfDatabaseEingabelisteHeaderBlock,
    DatabaseEingabelisteHeaderBlockFromJSON,
    DatabaseEingabelisteHeaderBlockFromJSONTyped,
    DatabaseEingabelisteHeaderBlockToJSON,
} from './DatabaseEingabelisteHeaderBlock';
import {
    DatabaseFinePrintHeaderBlock,
    instanceOfDatabaseFinePrintHeaderBlock,
    DatabaseFinePrintHeaderBlockFromJSON,
    DatabaseFinePrintHeaderBlockFromJSONTyped,
    DatabaseFinePrintHeaderBlockToJSON,
} from './DatabaseFinePrintHeaderBlock';
import {
    DatabaseHeaderBlock,
    instanceOfDatabaseHeaderBlock,
    DatabaseHeaderBlockFromJSON,
    DatabaseHeaderBlockFromJSONTyped,
    DatabaseHeaderBlockToJSON,
} from './DatabaseHeaderBlock';
import {
    DatabaseImageHeaderBlock,
    instanceOfDatabaseImageHeaderBlock,
    DatabaseImageHeaderBlockFromJSON,
    DatabaseImageHeaderBlockFromJSONTyped,
    DatabaseImageHeaderBlockToJSON,
} from './DatabaseImageHeaderBlock';
import {
    DatabaseNameHeaderBlock,
    instanceOfDatabaseNameHeaderBlock,
    DatabaseNameHeaderBlockFromJSON,
    DatabaseNameHeaderBlockFromJSONTyped,
    DatabaseNameHeaderBlockToJSON,
} from './DatabaseNameHeaderBlock';
import {
    DatabaseSubDbListHeaderBlock,
    instanceOfDatabaseSubDbListHeaderBlock,
    DatabaseSubDbListHeaderBlockFromJSON,
    DatabaseSubDbListHeaderBlockFromJSONTyped,
    DatabaseSubDbListHeaderBlockToJSON,
} from './DatabaseSubDbListHeaderBlock';
import {
    DatabaseTeaserImageHeaderBlock,
    instanceOfDatabaseTeaserImageHeaderBlock,
    DatabaseTeaserImageHeaderBlockFromJSON,
    DatabaseTeaserImageHeaderBlockFromJSONTyped,
    DatabaseTeaserImageHeaderBlockToJSON,
} from './DatabaseTeaserImageHeaderBlock';
import {
    DatabaseTextHeaderBlock,
    instanceOfDatabaseTextHeaderBlock,
    DatabaseTextHeaderBlockFromJSON,
    DatabaseTextHeaderBlockFromJSONTyped,
    DatabaseTextHeaderBlockToJSON,
} from './DatabaseTextHeaderBlock';
import {
    DatabaseTimestampHeaderBlock,
    instanceOfDatabaseTimestampHeaderBlock,
    DatabaseTimestampHeaderBlockFromJSON,
    DatabaseTimestampHeaderBlockFromJSONTyped,
    DatabaseTimestampHeaderBlockToJSON,
} from './DatabaseTimestampHeaderBlock';
import {
    DatabaseTitleHeaderBlock,
    instanceOfDatabaseTitleHeaderBlock,
    DatabaseTitleHeaderBlockFromJSON,
    DatabaseTitleHeaderBlockFromJSONTyped,
    DatabaseTitleHeaderBlockToJSON,
} from './DatabaseTitleHeaderBlock';
import {
    DatabaseVideoHeaderBlock,
    instanceOfDatabaseVideoHeaderBlock,
    DatabaseVideoHeaderBlockFromJSON,
    DatabaseVideoHeaderBlockFromJSONTyped,
    DatabaseVideoHeaderBlockToJSON,
} from './DatabaseVideoHeaderBlock';

/**
 * @type DatabaseHeaderPropertiesContentBlocksInner
 * 
 * @export
 */
export type DatabaseHeaderPropertiesContentBlocksInner = { blockType: 'BANNER' } & DatabaseBannerHeaderBlock | { blockType: 'BASE' } & DatabaseHeaderBlock | { blockType: 'CUSTOMER_LOGO' } & DatabaseCustomerLogoHeaderBlock | { blockType: 'DB_MENU' } & DatabaseDbMenuHeaderBlock | { blockType: 'DESCRIPTION' } & DatabaseDescriptionHeaderBlock | { blockType: 'EINGABELISTE' } & DatabaseEingabelisteHeaderBlock | { blockType: 'FINE_PRINT' } & DatabaseFinePrintHeaderBlock | { blockType: 'IMAGE' } & DatabaseImageHeaderBlock | { blockType: 'NAME' } & DatabaseNameHeaderBlock | { blockType: 'SUB_DB_LIST' } & DatabaseSubDbListHeaderBlock | { blockType: 'TEASER_IMAGE' } & DatabaseTeaserImageHeaderBlock | { blockType: 'TEXT' } & DatabaseTextHeaderBlock | { blockType: 'TIMESTAMP' } & DatabaseTimestampHeaderBlock | { blockType: 'TITLE' } & DatabaseTitleHeaderBlock | { blockType: 'VIDEO' } & DatabaseVideoHeaderBlock;

export function DatabaseHeaderPropertiesContentBlocksInnerFromJSON(json: any): DatabaseHeaderPropertiesContentBlocksInner {
    return DatabaseHeaderPropertiesContentBlocksInnerFromJSONTyped(json, false);
}

export function DatabaseHeaderPropertiesContentBlocksInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseHeaderPropertiesContentBlocksInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['blockType']) {
        case 'BANNER':
            return {...DatabaseBannerHeaderBlockFromJSONTyped(json, true), blockType: 'BANNER'};
        case 'BASE':
            return {...DatabaseHeaderBlockFromJSONTyped(json, true), blockType: 'BASE'};
        case 'CUSTOMER_LOGO':
            return {...DatabaseCustomerLogoHeaderBlockFromJSONTyped(json, true), blockType: 'CUSTOMER_LOGO'};
        case 'DB_MENU':
            return {...DatabaseDbMenuHeaderBlockFromJSONTyped(json, true), blockType: 'DB_MENU'};
        case 'DESCRIPTION':
            return {...DatabaseDescriptionHeaderBlockFromJSONTyped(json, true), blockType: 'DESCRIPTION'};
        case 'EINGABELISTE':
            return {...DatabaseEingabelisteHeaderBlockFromJSONTyped(json, true), blockType: 'EINGABELISTE'};
        case 'FINE_PRINT':
            return {...DatabaseFinePrintHeaderBlockFromJSONTyped(json, true), blockType: 'FINE_PRINT'};
        case 'IMAGE':
            return {...DatabaseImageHeaderBlockFromJSONTyped(json, true), blockType: 'IMAGE'};
        case 'NAME':
            return {...DatabaseNameHeaderBlockFromJSONTyped(json, true), blockType: 'NAME'};
        case 'SUB_DB_LIST':
            return {...DatabaseSubDbListHeaderBlockFromJSONTyped(json, true), blockType: 'SUB_DB_LIST'};
        case 'TEASER_IMAGE':
            return {...DatabaseTeaserImageHeaderBlockFromJSONTyped(json, true), blockType: 'TEASER_IMAGE'};
        case 'TEXT':
            return {...DatabaseTextHeaderBlockFromJSONTyped(json, true), blockType: 'TEXT'};
        case 'TIMESTAMP':
            return {...DatabaseTimestampHeaderBlockFromJSONTyped(json, true), blockType: 'TIMESTAMP'};
        case 'TITLE':
            return {...DatabaseTitleHeaderBlockFromJSONTyped(json, true), blockType: 'TITLE'};
        case 'VIDEO':
            return {...DatabaseVideoHeaderBlockFromJSONTyped(json, true), blockType: 'VIDEO'};
        default:
            throw new Error(`No variant of DatabaseHeaderPropertiesContentBlocksInner exists with 'blockType=${json['blockType']}'`);
    }
}

export function DatabaseHeaderPropertiesContentBlocksInnerToJSON(value?: DatabaseHeaderPropertiesContentBlocksInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['blockType']) {
        case 'BANNER':
            return DatabaseBannerHeaderBlockToJSON(value);
        case 'BASE':
            return DatabaseHeaderBlockToJSON(value);
        case 'CUSTOMER_LOGO':
            return DatabaseCustomerLogoHeaderBlockToJSON(value);
        case 'DB_MENU':
            return DatabaseDbMenuHeaderBlockToJSON(value);
        case 'DESCRIPTION':
            return DatabaseDescriptionHeaderBlockToJSON(value);
        case 'EINGABELISTE':
            return DatabaseEingabelisteHeaderBlockToJSON(value);
        case 'FINE_PRINT':
            return DatabaseFinePrintHeaderBlockToJSON(value);
        case 'IMAGE':
            return DatabaseImageHeaderBlockToJSON(value);
        case 'NAME':
            return DatabaseNameHeaderBlockToJSON(value);
        case 'SUB_DB_LIST':
            return DatabaseSubDbListHeaderBlockToJSON(value);
        case 'TEASER_IMAGE':
            return DatabaseTeaserImageHeaderBlockToJSON(value);
        case 'TEXT':
            return DatabaseTextHeaderBlockToJSON(value);
        case 'TIMESTAMP':
            return DatabaseTimestampHeaderBlockToJSON(value);
        case 'TITLE':
            return DatabaseTitleHeaderBlockToJSON(value);
        case 'VIDEO':
            return DatabaseVideoHeaderBlockToJSON(value);
        default:
            throw new Error(`No variant of DatabaseHeaderPropertiesContentBlocksInner exists with 'blockType=${value['blockType']}'`);
    }

}

